import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '@caslink/common-client/ng-app/helpers/AngularUpgradeHelper';
import { LoadingAnimationModule } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimationModule';
import { HardwareItemSyncLoadingAnimationComponent } from './hardware-item-sync-loading-animation.component';

@NgModule({
    imports: [
        LoadingAnimationModule
    ],
    exports: [
        HardwareItemSyncLoadingAnimationComponent
    ],
    entryComponents: [
        HardwareItemSyncLoadingAnimationComponent
    ],
    declarations: [
        HardwareItemSyncLoadingAnimationComponent
    ]
})
export class HardwareItemSyncLoadingAnimationModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            HardwareItemSyncLoadingAnimationComponent
        ]);
    }
}
